import React from "react";
import Slider from "react-slick";
import splash1 from "../../../../../../assets/images/svgs/header_people.svg";
import splash2 from "../../../../../../assets/images/svgs/header_doc.svg";
import splash3 from "../../../../../../assets/images/svgs/header_convo.svg";

const SimpleSlider = () => {
  const settings = {
    fade: true,
    infinite: true,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 5000,
    autoplaySpeed: 3000,
    arrows: false,
    initialSlide: 0,
  };

  const headerText = [
    {
      image: splash1,
      header: "Meet your old peers and connect with compass",
      detail:
        "Get an overview of how you are performing and motivate yourself to achieve even more",
    },
    {
      image: splash2,
      header: "Access to all school documents",
      detail:
        "Get an overview of how you are performing and motivate yourself to achieve even more",
    },
    {
      image: splash3,
      header: "See all your executives and what they are up to",
      detail:
        "Get an overview of how you are performing and motivate yourself to achieve even more",
    },
  ];

  const SliderContent = ({ content }) => {
    return (
      <div className="">
        <div className="flex justify-center">
          <img
            src={content.image}
            alt="splash4"
            className="text-center bg-yellow-100 rounded-full"
          />
        </div>
        <div className="mt-5">
          <h3 className="text-center text-2xl compass_color text-bolder">
            {content.header}
          </h3>
          {/* <h1 className="break-words text-center text-md compass_color">
            {content.detail}
          </h1> */}
        </div>
      </div>
    );
  };
  return (
    <div className="w-full">
      <Slider {...settings}>
        {headerText.map((content) => {
          return <SliderContent content={content} />;
        })}
      </Slider>
    </div>
  );
};

export default SimpleSlider;
